<template>
    <div class="layout__padding-clear layout__padding-8-0">
        <!--{{this.orders.length}}-->
        <div class="text__align-center">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="[20, 40, 60, 80, 100]"
                    :page-size="20"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="this.orders">
            </el-pagination>
        </div>
    </div>
</template>

<script>

    // import {paginationHelper} from '@/mixins/Pagination.js';

    export default {
        name: "pagination",
        props: {
            orders: Number,
            start: Number,
            end: Number,
            pagination: Number
        },
        // mixins: [paginationHelper],
        data() {
            return {
            }
        },
        created() {
        },
        methods: {
            handleSizeChange(val) {
                console.log(`${val} items per page`);

                this.$parent.pagination = val
                console.log(this.$parent.start)
                this.$parent.end = this.$parent.pagination;
                console.log(this.$parent.end)
            },
            handleCurrentChange(val) {
                console.log(`current page: ${val}`);

                this.$parent.start = (val - 1) * this.$parent.pagination + 1;
                console.log(this.$parent.start)
                this.$parent.end = val * this.$parent.pagination;
                console.log(this.$parent.end)
            },
        }
    };
</script>